export default __webpack_public_path__ + "static/Entenda0036-cb8d85d89d1f85d0d1a2c1ba366e9f2b.jpg";